import React, { Component } from 'react';
import Page from '../../components/Page';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import { toWapi } from '../../util/api';
import { Button, Segment, Table, Grid, GridColumn, Header, Modal, Icon } from 'semantic-ui-react';

class Phone extends Component {
	state = {
		phones: [],
		loading: false,
		targets: [],
		message_type: 'template',
		sw_groups: true,
		sw_contacts: false,
		start_date: new Date(),
	};
	async sendMessage() {
		return;
	}
	closeModal = () => {
		this.setState({ openModal: false });
	};
	render() {
		let { loading } = this.state;
		let { t } = this.props;

		let groups = [
			{
				name: 'WhiteHouseOnline',
				id: '@WhiteHouseOnline',
			},
		];

		if (loading) return <Page.Loader></Page.Loader>;
		return (
			<div>
				<Grid>
					<GridColumn width={16}>
						<Segment className="scroll">
							<div style={{ display: 'flex' }}>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									<Header>{t('Telegram Grup')}</Header>
								</div>
							</div>
							<Table>
								<Table.Header>
									<Table.Row>
										<Table.HeaderCell>{t('name')}</Table.HeaderCell>
										<Table.HeaderCell></Table.HeaderCell>
									</Table.Row>
								</Table.Header>
								<Table.Body>
									{_.map(groups, (it) => (
										<Table.Row>
											<Table.Cell>{it.name}</Table.Cell>
											<Table.Cell textAlign={'right'}>
												<Button positive onClick={() => this.setState({ openModal: true })}>
													{t('sendTemplate')}
												</Button>
											</Table.Cell>
										</Table.Row>
									))}
								</Table.Body>
							</Table>
						</Segment>
					</GridColumn>
				</Grid>
				<Modal open={this.state.openModal} onClose={this.closeModal} style={{ width: '900px', maxHeight: '600px' }}>
					<Header icon="telegram" content={t('sendMessage')} />
					<Modal.Content>
						<p style={{ display: 'flex', alignItems: 'center' }}>{t('sendTelegramsSure')}</p>
					</Modal.Content>
					<Modal.Actions>
						<div style={{ display: 'flex' }}>
							<div style={{ marginLeft: 'auto' }}>
								<Button color="red" onClick={this.closeModal}>
									<Icon name="remove" /> {t('no')}
								</Button>
								<Button color="green" onClick={() => this.sendMessage()}>
									<Icon name="checkmark" /> {t('yes')}
								</Button>
							</div>
						</div>
					</Modal.Actions>
				</Modal>
			</div>
		);
	}
}
const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.live,
	user: state.access.user.loggedUserObj,
});
export default connect(stateToProps)(withTranslation()(Phone));
